export default {
  "Header": {
    "title": "Das KickerEck - Kickern in Dortmund"
  },
  "Modus": [
    {
      "icon": "MDYP.svg",
      "name": "Monster-DYP",
      "text": "Monster-DYP steht für \"Draw Your Partner\". Bei dieser Turnierform werden die Spieler in jeder Runde neu gemischt und per Zufall einem Partner zugeteilt. Dies sorgt für Abwechslung und Chancengleichheit, da man immer wieder mit verschiedenen Mitspielern antritt. Ideal, um neue Leute kennenzulernen und verschiedene Spielstile zu erleben."
    },
    {
      "icon": "Doppel.svg",
      "name": "Offenes Doppel",
      "text": "Beim offenen Doppel treten feststehende Zweierteams gegeneinander an. Jedes Team bleibt während des gesamten Turniers zusammen und spielt gemeinsam um den Sieg. Perfekt für eingespielte Teams, die ihre Zusammenarbeit und Taktiken verbessern möchten."
    },
    {
      "icon": "Einzel.svg",
      "name": "Offenes Einzel",
      "text": "Beim offenen Einzel spielt jeder Spieler für sich allein und tritt gegen andere Einzelspieler an. Es ist ein klassisches Eins-gegen-Eins-Format. Hervorragend, um individuelle Fähigkeiten zu testen und zu verbessern."
    }
  ],
  "Contact": {
    "email": "kickereck@gmail.com",
    "facebook": "https://www.facebook.com/Tischfussballverstrahlt",
    "twitter": "twitter.com",
    "youtube": "youtube.com"
  }
};